import { z } from "@/zod";
import { ulid } from "@/schemas/commonFields";

const wizardAllocation = z.object({
  id: ulid,
  project_id: ulid,
  project_ref_number: z.number(),
  project_name: z.string(),
  project_status: z.string(),
  store_id: ulid,
  store_ref_number: z.number(),
  store_name: z.string(),
  store_status: z.string(),
  store_network_id: ulid.nullable(),
  store_network: z.string().nullable(),
  store_format_id: ulid.nullable(),
  store_format: z.string().nullable(),
  city: z.string().nullable(),
  street_name: z.string().nullable(),
  street_number: z.string().nullable(),
  apartment_number: z.string().nullable(),
  postal_code: z.string().nullable(),
  province_id: ulid.nullable(),
  province: z.string().nullable(),
  project_role_id: ulid,
  project_role_name: z.string(),
  deleted_at: z.string().datetime().nullable(),
});

export const readContractorsPlannedHoursWizardAllocation =
  wizardAllocation.readonly();

export const displayContractorsPlannedHoursWizardAllocation = wizardAllocation
  .omit({
    store_network_id: true,
    store_format_id: true,
    province_id: true,
    project_role_id: true,
    deleted_at: true,
  })
  .readonly();

export const calculateContractorsPlannedHoursWizardRequest = z.object({
  schedules: z.array(ulid),
});

const wizardResultCore = z.object({
  period: z.string(),
  hours: z.coerce.string(),
});

export const readContractorsPlannedHoursWizardResult =
  wizardResultCore.readonly();

export const displayContractorsPlannedHoursWizardResult = wizardResultCore
  .extend({ id: z.string() })
  .readonly();
